import dayjs, { Dayjs } from "dayjs";

export function parseDateInUtc(date: Date | string): Dayjs {
  const ymd =
    date instanceof Date
      ? dayjs(date).utc().format("YYYY-MM-DD")
      : dayjs(date).format("YYYY-MM-DD");
  return dayjs.tz(ymd, "UTC").utc();
}

export function getStartOfWeek(date: Date | string): Dayjs {
  return parseDateInUtc(date).startOf("week");
}

export function getEndOfWeek(date: Date | string): Dayjs {
  return parseDateInUtc(date).endOf("week");
}

export function computeEndAtWeekFromStartAndWeeks(
  start: Date | string,
  weeks: number,
): Date {
  return getStartOfWeek(start)
    .add(weeks - 1, "week")
    .endOf("week")
    .toDate();
}

export function computeWeeksBetween(
  start: Date | string,
  end: Date | string,
): number {
  return getEndOfWeek(end).diff(getStartOfWeek(start), "week") + 1;
}
